import { render, staticRenderFns } from "./FCDashboardTable.vue?vue&type=template&id=084a2e94&scoped=true&"
import script from "./FCDashboardTable.vue?vue&type=script&lang=js&"
export * from "./FCDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./FCDashboardTable.vue?vue&type=style&index=0&id=084a2e94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a2e94",
  null
  
)

export default component.exports